import React from "react";
import { connect } from "react-redux";
import "./_NecklaceSelectList.scss";
import { withRouter } from "react-router-dom";
import {
  selectActiveNecklaceFromModal,
  selectActiveMemoryInModal,
  toggleShowEditMemoryInModal,
} from "../../redux/actions";
import queryString from "query-string";
import { SelectListItem } from "..";

class NecklaceSelectList extends React.Component {
  renderItems = () => {
    const {
      necklaces,
      modalNecklaceOpen,
      memories,
      selectedMemoryCollections,
    } = this.props;
    // List Main Rings:
    if (modalNecklaceOpen) {
      if (necklaces && necklaces.items) {
        if (necklaces.items.length && necklaces.items.length > 0) {
          return necklaces.items.map((item) => {
            return (
              <React.Fragment key={item.fields.title}>
                {this.getItem(item, "yellow-gold")}
                {this.getItem(item, "rose-gold")}
                {this.getItem(item, "white-gold")}
              </React.Fragment>
            );
          });
        }
      }
    } else {
      if (memories && memories.items) {
        return memories.items.map((item) => {
          let render = false;
          if (
            selectedMemoryCollections &&
            selectedMemoryCollections.length > 0
          ) {
            if (selectedMemoryCollections.includes(item.sys.id)) {
              render = true;
            }
          } else {
            render = true;
          }
          if (render) {
            return (
              <React.Fragment key={item.fields.title}>
                {this.getItem(item, "yellow-gold", "memory")}
                {this.getItem(item, "rose-gold", "memory")}
                {this.getItem(item, "white-gold", "memory")}
              </React.Fragment>
            );
          }
          return null;
        });
      }
    }
  };

  getItem = (item, material = "yellow-gold", type = "necklace") => {
    let imageURL = "";
    let price = 0;
    let materialText = "Keltakulta";
    const title =
      type === "necklace" ? item.fields.collectionTitle : item.fields.title;
    switch (material) {
      case "rose-gold":
        imageURL =
          type === "necklace"
            ? item.fields.imageRoseGoldURL
            : item.fields.imageRoseGoldMainURL;
        price = item.fields.priceRoseGold;
        materialText = "Ruusukulta";
        break;
      case "white-gold":
        imageURL =
          type === "necklace"
            ? item.fields.imageWhiteGoldURL
            : item.fields.imageWhiteGoldMainURL;
        price = item.fields.priceWhiteGold;
        materialText = "Valkokulta";
        break;
      default:
        imageURL =
          type === "necklace"
            ? item.fields.imageYellowGoldURL
            : item.fields.imageYellowGoldMainURL;
        price = item.fields.priceYellowGold;
        break;
    }
    return (
      <SelectListItem
        title={title}
        material={materialText}
        priceText="Hinta"
        price={price}
        imageURL={imageURL}
        onPress={() => this.onButtonPress(item, material, type)}
      />
    );
  };

  onButtonPress = (item, material = "yellow-gold", type = "necklace") => {
    if (type === "necklace") {
      this.props.selectActiveNecklaceFromModal(item);
      this.changeURLNecklace(item, material);
    } else {
      const { modalMemoryIndex } = this.props;
      this.props.selectActiveMemoryInModal(item, modalMemoryIndex, material);
    }
  };

  changeURLNecklace = (newItem, material = "yellow-gold") => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    queryParams.necklace = newItem.sys.id;
    queryParams["necklace-material"] = material;
    queryParams.collection = newItem.fields.collectionTitle;
    history.push({
      pathname: "/",
      search: queryString.stringify(queryParams),
    });
  };

  render() {
    return <div className="necklace-select-list">{this.renderItems()}</div>;
  }
}

const mapStateToProps = ({ necklace, configuratorPageNecklace }) => {
  const {
    necklaces,
    memories,
    activeNecklace,
    activeMemories,
    selectedMemoryCollections,
  } = necklace;

  const {
    modalNecklaceOpen,
    modalMemoriesOpen,
    modalMemoryIndex,
    modalActiveMemory,
  } = configuratorPageNecklace;

  return {
    necklaces,
    memories,
    activeNecklace,
    activeMemories,
    modalNecklaceOpen,
    modalMemoriesOpen,
    modalMemoryIndex,
    modalActiveMemory,
    selectedMemoryCollections,
  };
};

export default connect(mapStateToProps, {
  selectActiveNecklaceFromModal,
  selectActiveMemoryInModal,
  toggleShowEditMemoryInModal,
})(withRouter(NecklaceSelectList));
